import { CircularProgress } from '@mui/material';
import AppAdminTable from 'components/AppAdminTable/AppAdminTable';
import ListPage from 'components/ListPage/ListPage';
import Pagination from 'components/Pagination/Pagination';
import { TableColumns } from 'helpers/tableColumns';
import { useRemoteResource } from 'hooks/useRemoteResource';
import { Link } from 'react-router-dom';
import airportsSAService from 'services/superadmin/airportsSAService';

const listConfig = [
    {
        key: "id",
        label: "ID"
    },
    {
        key: "name",
        label: "Название",
        render: (a) => {
            return <Link to={`edit/${a.id}`} className='color-blue'>{a.name}</Link>
        }
    },
    {
        key: "airportCode",
        label: "Код аэропорта",
    },
    {
        key: "country.name",
        label: "Страна",
    },
    {
        key: "city.name",
        label: "Город",
    },
    TableColumns.createdDate
]

export const AirportList = () => {
    const [data, loadData, loading] = useRemoteResource(airportsSAService.getAll, "");

    const onDelete = async (item) => {
        await airportsSAService.delete(item.id);
        loadData();
    };

    if (loading) {
        return <div className="text-center"><CircularProgress></CircularProgress></div>
    }

    return (
        <ListPage pageTitle="Список аэропортов">
            <AppAdminTable
                columnConfig={listConfig}
                data={data?.data || []}
                onDelete={onDelete}
                loading={loading}
            />
            {data && <Pagination total={data.total} limit={50} />}
        </ListPage>
    );
}
